// Some translations are missing, so we need to add them here.
// https://translations.trustup.io/admin/translations?app_keys%5B%5D=all&default=be-fr&requested=be-nl&empty_translation=&order_by=desc&is_checked=&search=badge_status.
export const BADGE_STATUS = {
    NEW: 'new',
    GRADIENT: 'gradient',
    DUE: 'due',
    LATE: 'late',
    PAID: 'paid',
    OVERDUE: 'overdue',
    DRAFT: 'draft',
    SENT: 'sent',
    COMPLETED: 'completed',
    WARNING: 'warning',
    REFUSED: 'refused',
    ONGOING: 'ongoing',
    ARCHIVED: 'archived',
    FUTURE: 'future',
    IN_PROGRESS: 'in_progress',
    TO_PAY: 'to_pay',
    IS_LATE: 'is_late',
    DONE: 'done',
    NULL: 'null',
    PENDING: 'pending',
    ACCEPTED: 'accepted',
    VALIDATED: 'validated',
    DELIVERED: 'delivered',
    SUCCESS: 'success',
    PROCESSED: 'processed',
    FAILED: 'failed',
    EXTERNAL_FAILURE: 'external-failure',
    INTERNAL_FAILURE: 'internal-failure',
    ERROR: 'error',
    VALIDATION_REQUESTED: 'validation_requested',
    RESERVES_RAISED_TENANT_SIGNATURE: 'reserves_raised_tenant_signature',
    RESERVES_REMOVED_AWAITING_CLIENT_SIGNATURE: 'reserves_removed_awaiting_client_signature',
    COMPLETED_AWAITING_TENANT_SIGNATURE: 'completed_awaiting_tenant_signature',
    RESERVES_RAISED_AWAITING_CLIENT_SIGNATURE: 'reserves_raised_awaiting_client_signature',
    RESERVES_RAISED_AWAITING_TENANT_SIGNATURE: 'reserves_raised_awaiting_tenant_signature',
} as const;

export type BadgeStatus = Enum<typeof BADGE_STATUS>;
